import React, { cloneElement } from "react"
import { Table } from "@material-ui/core"

const tableType = <Table/>

export const DenseTableMd = (props) =>
    props.children.map(c => c?.type !== tableType
        ? c
        : cloneElement(c, { size: "small" }))